// External Libraries and Packages
import { Navigate, Route, Routes } from "react-router-dom";
import React, { Suspense, lazy } from "react";
// Import Components
import PageLoader from '../components/PageLoader';
import AdvertiserLogIn from '../AdvertiserPortal/Components/Login&Signup/AdvertiserLogIn';
import AdvertiserSignUp from '../AdvertiserPortal/Components/Login&Signup/AdvertiserSignUp';
import AdvertiserCommonLayout from "../AdvertiserPortal/Components/Layout/AdvertiserCommonLayout";
import AdvertiserDashBoard from '../AdvertiserPortal/Components/AdvertiserDashBoard';
import AdvertisementList from '../AdvertiserPortal/Components/AdvertisementList';
import AdvertiserProfile from '../AdvertiserPortal/Components/Layout/AdvertiserProfile';
import AdvertisementCreate from '../AdvertiserPortal/Components/AdvertisementCreate';
import AdvertisementEdit from '../AdvertiserPortal/Components/AdvertisementEdit';
import ScheduleAdvertisement from '../AdvertiserPortal/Components/ScheduleAdvertisement';
import AdvertiserPlans from '../AdvertiserPortal/Components/AdvertiserPlans';
import SSAIMonitoring from '../AdvertiserPortal/Components/SSAIMonitoring';
import SSAICampaignList from '../AdvertiserPortal/Components/SSAICampaignList';
import SSAICampaignCreate from '../AdvertiserPortal/Components/SSAICampaignCreate';
import SSAICampaignEdit from '../AdvertiserPortal/Components/SSAICampaignEdit';
import SSAITestPlayer from '../AdvertiserPortal/Components/SSAITestPlayer';
import MonetizationEnabledRoute from './MonetizationEnabledRoute';
import HomeProtectedRoute from './HomeProtectedRoute';
import Error404 from '../components/Error404';

const AdvertiserRoutes = () => {
     const token = localStorage.getItem("access_token");
     // console.log("token",token);

     return (
          <Suspense fallback={<PageLoader />}>
               <Routes>
                    <Route path='/login' element={<AdvertiserLogIn />} />
                    <Route path='/signup' element={<AdvertiserSignUp />} />
                    <Route path='/' element={<HomeProtectedRoute> <AdvertiserCommonLayout /> </HomeProtectedRoute>} >
                         <Route path="/ads-dashboard" element={<AdvertiserDashBoard />} />
                         <Route path="/ads-list" element={<AdvertisementList />} />
                         <Route path="/ads-create" element={<AdvertisementCreate />} />
                         <Route path="/ads-edit/:id" element={<AdvertisementEdit />} />
                         <Route path="/schedule-ads" element={<ScheduleAdvertisement />} />
                         <Route path="/ssai-monitoring" element={<SSAIMonitoring />} />
                         <Route path="/ssai-campaigns" element={<SSAICampaignList />} />
                         <Route path="/ssai-campaigns/create" element={<SSAICampaignCreate />} />
                         <Route path="/ssai-campaign-create" element={<SSAICampaignCreate />} />
                         <Route path="/ssai-campaign-edit/:id" element={<SSAICampaignEdit />} />
                         <Route path="/ssai-tester" element={<SSAITestPlayer />} />
                         <Route path="/plans" element={<MonetizationEnabledRoute><AdvertiserPlans /></MonetizationEnabledRoute>} />
                         <Route path='/account_detail' element={<AdvertiserProfile />} />
                         <Route path="*" element={<Error404 />} />
                    </Route>
               </Routes>
          </Suspense>
     );
};

export default AdvertiserRoutes;
